import React, { useState, useMemo } from "react";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { NonFormSwitch } from "../../../components/lists/listComponents/Switch";
import Spinner from "../../../components/icons/Spinner";
import { useCampaignReport } from "../../../utils/api/reports";
import { processReports } from "../../../utils/helperfuctions";
import WebsiteRevenue from "./BillingComponents/WebsiteRevenue";
import PublisherCampaignRevenue from "./BillingComponents/PublisherCampaignRevenue";

const RevenueNew = () => {
  const { user } = useCurrentUser();
  const [startOfMonth, setStartOfMonth] = useState(dayjs().startOf("month"));
  const [endOfMonth, setEndOfMonth] = useState(dayjs().endOf("month"));
  const [showCampaigns, setShowCampaigns] = useState(false);

  const queryStart = useMemo(
    () => startOfMonth.format("YYYY-MM-DD"),
    [startOfMonth]
  );
  const queryEnd = useMemo(
    () => endOfMonth.format("YYYY-MM-DD"),
    [endOfMonth]
  );

  const memoizedFilters = useMemo(
    () => ({ publisherId: user.companyId }),
    [user.companyId]
  );

  const {
    loading: campiLoading,
    error: campiError,
    data: campiData,
  } = useCampaignReport({
    startDate: queryStart,
    endDate: queryEnd,
    filters: memoizedFilters,
  });

  const onDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setStartOfMonth(dates[0]);
      setEndOfMonth(dates[1]);
    }
  };

  let uniqueCampaignIds = [];
  let websiteMappings = {};
  let campaignMappings = {};

  if (!campiLoading && !campiError && campiData) {
    ({ uniqueCampaignIds, websiteMappings, campaignMappings } =
      processReports(campiData.CampaignReport));
  }

  if (campiLoading) {
    return <Spinner />;
  }

  if (campiError) {
    return <div className="shadow border rounded-lg p-4 text-red-500">
      Error loading data. Please try again.
    </div>;
  }

  const noData = (
    <div className="shadow border rounded-lg p-4">
      No campaigns in the date interval
    </div>
  );

  return (
    <div className="pb-4 bg-white rounded-lg shadow-lg py-2">
      <div className="px-2 sm:px-6 lg:px-4 py-4">
        <div className="sm:flex sm:items-center p-2">
          <div className="sm:flex-auto">
            <h1 className="text-lg leading-6 font-medium text-gray-900 pb-2">
              Revenue
            </h1>
            <DatePicker.RangePicker
              allowClear={false}
              onChange={onDateChange}
              value={[startOfMonth, endOfMonth]}
            />
          </div>
          <h3 className="text-sm leading-6 font-medium text-gray-900 px-2">
            Show Campaign Details
          </h3>
          <NonFormSwitch
            name="Campaign Details"
            setShowCampaigns={setShowCampaigns}
            showCampaigns={showCampaigns}
          />
        </div>

        {uniqueCampaignIds.length > 0 ? (
          !showCampaigns ? (
            <WebsiteRevenue
              user={user}
              queryStart={queryStart}
              queryEnd={queryEnd}
              uniqueCampaignIds={uniqueCampaignIds}
              websiteMappings={websiteMappings}
            />
          ) : (
            <PublisherCampaignRevenue
              user={user}
              queryStart={queryStart}
              queryEnd={queryEnd}
              uniqueCampaignIds={uniqueCampaignIds}
              websiteMappings={websiteMappings}
              campaignMappings={campaignMappings}
            />
          )
        ) : (
          noData
        )}
      </div>
    </div>
  );
};

export default RevenueNew;
